<template>
  <artmisads-modal :open="open" :title="title" :width="1000" :maskClosable="false"
    :onCancel="() => open = false" :destroyOnClose="true">
  <div class="table-head">
    <a-space>
      <!-- <ButtonGroups :pagination="pagination" :tableData="dataSource" @pageChange="onPageChange" /> -->
       <ButtonGroups :pagination="{
            total: pagination.total,
            page: pagination.current,
            size: pagination.size,
          }" :tableData="dataSource" @pageChange="onPageChange" />
    </a-space>
    <a-space>
     
        <span style="padding-right: 10px;padding-left: 10px;">Associate Status:</span>
         <div ref="brandRef">
       <artmisads-select allowClear class="width80" :options="statusOptions" v-model:value="associateStatus"
              @change="() => { pagination.current = 1;getProductsList()
 }"
              @clear="() => { associateStatus = ''; pagination.current = 1;getProductsList()
 }"
              :getPopupContainer="() => $refs.brandRef" />
      </div>
        <span style="padding-right: 10px;">ASIN:</span>
      <a-input-search v-model:value="asin" class="width80" placeholder="Search..." allow-clear @search="onSearch"
            @enter="onSearch">
      </a-input-search>
       <span style="padding-right: 10px;">keywords:</span>
      <a-input-search v-model:value="keywords" class="width80" placeholder="Search..." allow-clear @search="onSearch"
            @enter="onSearch">
      </a-input-search>
    </a-space>
  </div>
   
    <artmisads-table v-model:pagination="pagination" :columns="columns" :data-source="dataSource"
        
        :change="onTableChange" :loading="load" >
         <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'Product'">
            <div class="product-item" style="width: 300px;" @click="handleClick(record)">
             
              <LogoImage :previewShow="false" :logoUrl="record.productImageUrl"  :brandName="record.productTitle"/>
          <!-- <img :src='record.productImageUrl' /> -->
          <div class="text">
            <p class="title">{{record.productTitle}}</p>
            <div class="asin-vc-icon">
              <span class="asin">{{record.asin}}</span>
            </div>
          </div>
          </div>
          </template>
          <template v-else-if="column.key === 'publisher'">
             <div class="product-item">
          <LogoImage :previewShow="false" :logoUrl="record.avatarPath" :brandName="record.creatorName"/>
          <div class="text">
            <p class="title">{{record.creatorName}}</p>
          
          </div>
          </div>
          </template>
          <template v-else-if="column.key === 'associateCommissionRate'">
            <span>{{ record.associateCommissionRate? record.associateCommissionRate : '--' }}%</span>
          </template>
          <template v-if="column.key === 'productPrice'||column.key === 'sales'">
            <span>{{ CURRENCY_DATA_MAPPER[record.currencyCode] }} {{record[column.key]}}</span>
          </template>
          <template v-else-if="column.key === 'content'">
            <span>{{ returnContent(record) }}</span>
          </template>
          <template v-else-if="column.key === 'artemisAdsStatus'">
            <artmisads-button type="primary" size="small" v-if="record.artemisAdsStatus">
              CLAIMED
            </artmisads-button>
            <artmisads-button type="primary" :disabled="true" size="small" v-else>
              UNCLAIMED
            </artmisads-button>
          </template>
        </template>
      </artmisads-table>
  </artmisads-modal>
</template>
<script setup lang="jsx">
import { ref ,defineExpose,reactive} from 'vue'
import { associateCentralApi } from '~/server/index'
import { message } from 'ant-design-vue'
import { CURRENCY_DATA_MAPPER } from '@/contants/common'
import ButtonGroups from '~/components/buttonGroups.vue'
import LogoImage from '@/components/LogoImage.vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const campaignId = ref('')
const keywords = ref('')
const asin=ref('')
const associateStatus=ref('')
const marketplace = ref('')
const open = ref(false)
const title = ref('Campaign Products')
const pagination = ref({
  total: 0,
  defaultPageSize: 10,
  size: 10,
  current: 1,
  showSizeChanger: true,
  pageSize: 10,
  pageSizeOptions: ['10', '20', '30', '40', '50']
})
const statusOptions= ref([
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'InActive',
    value: 'inactive',
  },
])
const columns = ref([
  {
    title: 'Product',
    dataIndex: 'Product',
    key: 'Product',
  },
  {
    title:'Price',
    dataIndex:'productPrice',
    key:'productPrice',
  },
  {
    title:'AssociateStatus',
    dataIndex:'associateStatus',
    key:'associateStatus',
  },
  {
    title:'Availability',
    dataIndex:'availability',
    key:'availability',
  }
])
const dataSource = ref([])
const load = ref(false)
const onTableChange = ({ current, pageSize }) => {
  pagination.value.current = current
  pagination.value.size = pageSize
  pagination.value.pageSize = pageSize
  if(title.value === 'Campaign Products'){
    getProductsList()
  }else{
    getCampaignPublishersList()
  }
  // getData({ page: current, size: pageSize })
}
const onPageChange = (page) => {
 
  pagination.value.current = page;
   if(title.value === 'Campaign Products'){
    getProductsList()
  }else{
    getCampaignPublishersList()
  }
}
const openModal = (type,id,marketplaceStr) => {
  open.value = true
  marketplace.value = marketplaceStr
  campaignId.value = id
  pagination.value = {
  total: 30,
  defaultPageSize: 10,
  size: 10,
  current: 1,
  showSizeChanger: true,
  pageSize: 10,
  pageSizeOptions: ['10', '20', '30', '40', '50']
}
  keywords.value = ''
  
  title.value = type === 'products' ? 'Campaign Products' : 'Campaign Publishers'

  if(type === 'products'){
    columns.value=[
  {
    title: 'Product',
    dataIndex: 'Product',
    key: 'Product',
     width:'150px',
  },
 
  {
    title:'Price',
    dataIndex:'productPrice',
    key:'productPrice',
  },
  {
    title:'Associate Commission',
    dataIndex:'associateCommissionRate',
    key:'associateCommissionRate',
  },
  {
    title:'Associate Status',
    dataIndex:'associateStatus',
    key:'associateStatus',
  },
  {
    title:'Availability',
    dataIndex:'availability',
    key:'availability',
  }
]
getProductsList()
  }else{
    columns.value=[
   {
    title: 'Publisher',
    dataIndex: 'publisher',
    key: 'publisher',
    width:'150px',
  },
  {
    title:'Content',
    dataIndex:'content',
    key:'content',
  },
  {
    title:'Sales',
    dataIndex:'sales',
    key:'sales',
  },
  {
    title:'ArtemisAds Status',
    dataIndex:'artemisAdsStatus',
    key:'artemisAdsStatus',
  }
]
getCampaignPublishersList()
  }
}
const onSearch=()=>{
  pagination.value.current = 1;
   if(title.value === 'Campaign Products'){
    getProductsList()
  }else{
    getCampaignPublishersList()
  }
  // getData({ page: 1, size: pagination.size, keywords: keywords.value })
}
const getProductsList = async () => {
  load.value = true
  const res = await associateCentralApi.getAssociateCampaignProductsList({
    page: pagination.value.current,
    size: pagination.value.size,
    keyword: keywords.value,
    asin:asin.value,
    campaignId: campaignId.value,
    marketplace:marketplace.value,
    associateStatus:associateStatus.value
  })
  const { data, success, error } = res
  if (success) {
   
    dataSource.value = data.data
    pagination.value.total = data.total
  }else{
    message.error(error)
  }
  load.value = false
}
const getCampaignPublishersList = async () => {
  load.value = true
  const res = await associateCentralApi.getCampaignPublishersList({
    page: pagination.value.current,
    size: pagination.value.size,
    keyword: keywords.value,
    campaignId: campaignId.value,
  })
  const { data, success, error } = res
  if (success) {
    dataSource.value = data.data
    pagination.value.total = data.total
  }else{
    message.error(error)
  }
  load.value = false
}
const returnContent = (record) => {
  if(record?.content?.length > 0){
    return record.content.join(',')
  }
  return 'No content submitted'
}
const handleClick = (record) => {
  console.log(record,'数据','/publisher/products/'+record.productId,)
  router.push({
    path: `/publisher/products/${record.productId}`,
  
  })
}
defineExpose({
openModal
})
</script>
<style scoped lang="less">
.width80{
  width: 160px;
}
.width100{
  width: 200px;
}
.table-head {
  display: flex;
  height: 64px;
  justify-content: space-between;
  align-items: center;
  }
 .product-item {
    display: flex;
    cursor: pointer;
    // width: 300px;
    max-width: 200px;
    gap: 6px;
    .asin-vc-icon{
      display: flex;
      align-items: center;
      // justify-content: flex-end;
      gap: 4px;
    }
    img {
      width: 56px;
      height: 56px;
      margin-right: 12px;
      // border: 1px solid var( --border-1);
      border-radius: 8px;
      object-fit: contain;
    }

    .text {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      justify-content: center;

      .title {
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: var(--dark-1);
        font-weight: 500;
        font-size: var(--font-size-middle);
        text-decoration: underline;
      }

      .asin {
        color: var(--dark-3);
        font-weight: 500;
        font-size: var(--font-size-min);
        letter-spacing: 0.3px;
        text-align: right;
        line-height: 16px;
        text-align: left;
        margin-top: 2px;
      }
    }
  }
  
</style>
